import { useContext } from 'react'

import Link from '@atoms/Link'
import MicrocmsImage from '@atoms/MicrocmsImage'
import SaveButton from '@molecules/SaveButton'
import VoicePlayButton from '@molecules/VoicePlayButton'
import MaskedIcon from '@icons/Masked'
import { StoreContext } from '@models/Store'
import { Article } from '@models/Article'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

type ArticleItemProps = {
  article: Article
  rank?: number
  listRule?: 'sp' | 'tab' | 'smallTab' | 'pc' | 'no-list'
  type?: 'normal' | 'large' | 'flex'
  gtmClickType?: string
}
const ArticleItem = ({
  article,
  rank,
  listRule = 'sp',
  type = 'normal',
  gtmClickType = 'unknown',
}: ArticleItemProps) => {
  const { entity } = useContext(StoreContext)
  const { navigate } = useTranslation()
  const isMasked = entity?.user?.isSignIn !== true && article.isMembersOnly

  return (
    <Link
      className={style.card}
      to={article.path}
      data-list-rule={listRule}
      data-type={type}
    >
      {rank !== undefined && (
        <div className={style.rank}>
          <span>{rank}</span>
        </div>
      )}
      <div className={style.imageContainer}>
        <MicrocmsImage
          image={article.thumbnail}
          alt={article.title}
          type={type === 'normal' ? 'thumbnail' : 'hero'}
          disableAspectRatio
        />
      </div>
      <div className={style.info}>
        <p className={style.title}>
          {isMasked && (
            <span className={style.masked}>
              <MaskedIcon />
            </span>
          )}
          {article.title}
        </p>
        <div className={style.meta}>
          <div
            className={style.category}
            onClick={event => {
              event.preventDefault()
              navigate(`/${article.data.category}`)
            }}
          >
            {article.data.category.toUpperCase()}
          </div>
          <time className={style.date}>{article.publishDate}</time>

          {article.enableVoice && (
            <div
              className={style.voiceContainer}
              data-gtm-click={`play-list-${gtmClickType}`}
              data-gtm-value={article.blogId}
            >
              <VoicePlayButton article={article} size="small" />
            </div>
          )}

          <div
            className={style.saveContainer}
            data-gtm-click={`save-list-${gtmClickType}`}
            data-gtm-label={entity.bookmark[article.blogId] !== true}
            data-gtm-value={article.blogId}
          >
            <SaveButton
              blogId={article.blogId}
              active={entity.bookmark[article.blogId] === true}
              size="small"
            />
          </div>
        </div>
      </div>
    </Link>
  )
}

export default ArticleItem
